export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10981.c1592497.jpg";